export default __webpack_public_path__ + "static/media/Student.839b2c4d.png";